import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { numbers } from 'app/utils';
import { Box, View, BodyText, Row } from 'modules/styled';
import { elementTypePropTypeChecker } from 'utils/propValidation';
import { getTimestamp } from 'utils/numbers';
import { computeUserPayout } from 'app/utils/rewards';
import { useCommunity } from 'modules/community/community.selectors';
import { PAYOUT_DELAY } from '@r3l/common';
export default class Earning extends PureComponent {
  static propTypes = {
    earning: PropTypes.object,
    month: PropTypes.string,
    screenSize: PropTypes.number,
    PostPreview: elementTypePropTypeChecker,
  };

  render() {
    const { earning, month, screenSize, PostPreview } = this.props;
    const { community, post } = earning;
    if (!earning) return null;

    const monthEl = month && (
      <View sx={{ mt: 4 }}>
        <BodyText>{month.toUpperCase()}</BodyText>
      </View>
    );

    return (
      <View sx={{ mx: [2, 4] }} key={earning._id}>
        {monthEl}
        <Header earning={earning} date={earning.createdAt} />
        {post ? (
          <View sx={{ variant: 'borders.navBorder', borderWidth: [0, 1] }}>
            <PostPreview screenSize={screenSize} community={community} postId={post} />
          </View>
        ) : null}
      </View>
    );
  }
}

Header.propTypes = {
  earning: PropTypes.object,
};

function Header({ earning }) {
  const {
    status = '',
    payoutTime,
    cashOutAttempt,
    cashOutAmt,
    post,
    createdAt,
  } = earning;
  const payoutDate = new Date(payoutTime);
  const adjustedTime = new Date(payoutDate.getTime() + PAYOUT_DELAY);

  const payoutTimeFormat = status === 'pending' && getTimestamp(adjustedTime);
  const community = useCommunity(earning.community);
  const text = earning.cashOutAttempt
    ? `Transfer tokens to Ethereum wallet: ${status}`
    : `${status}${payoutTimeFormat ? ' ' + payoutTimeFormat.toLowerCase() : ''}`;

  const payout = cashOutAttempt ? -cashOutAmt : computeUserPayout(earning, community);
  const date = createdAt && numbers.getDayMonthYearTimestamp(createdAt);
  return (
    <Box sx={{ bg: 'lightGreyBg', mt: 2 }}>
      <View
        sx={{
          py: 1.5001 * 8,
          px: 1,
          variant: 'borders.navBorder',
          borderWidth: 1,
          borderBottomWidth: !post ? 1 : 0,
          flexDirection: 'row',
          justifyContent: 'space-between',
          flex: 1,
        }}
      >
        <Row sx={{ flexWrap: 'wrap', flex: 1 }}>
          <BodyText sx={{ mr: [2, 4] }}>{date}</BodyText>
          <BodyText sx={{ color: 'grey' }}>{text}</BodyText>
        </Row>
        {payout < 0 ? (
          <BodyText sx={{ color: 'red' }}>
            {numbers.abbreviateNumber(payout)} REL
          </BodyText>
        ) : (
          <BodyText sx={{ color: 'green' }}>
            +{numbers.abbreviateNumber(payout)} REL
          </BodyText>
        )}
      </View>
    </Box>
  );
}
